import {
  Divider,
  Header,
  Modal,
  PrimaryButton,
  Space,
  TextButton,
} from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { ActiveCardholderAccountRequiredModalStyled } from './styles/ActiveCardholderAccountRequiredModalStyled'

export interface IActiveCardholderAccountRequiredModalProps {
  open: boolean
  onDismiss: () => void
  onClickSetupButton: () => void
  onClickRequestButton: () => void
}

export const ActiveCardholderAccountRequiredModal = ({
  open,
  onDismiss,
  onClickSetupButton,
  onClickRequestButton,
}: IActiveCardholderAccountRequiredModalProps) => {
  const intl = useProcurifyIntl()

  return (
    <Modal maxWidth='sm' open={open} onClose={onDismiss}>
      <Modal.Card>
        <Modal.Header onClose={onDismiss}>
          <Header as='h3'>{intl.formatMessage(messages.title)}</Header>
        </Modal.Header>
        <Modal.Content>
          <Space>
            <ActiveCardholderAccountRequiredModalStyled>
              {intl.formatMessage(messages.description)}
            </ActiveCardholderAccountRequiredModalStyled>
            <Divider />
            <Space align='end'>
              <Space direction='horizontal' align='center'>
                <TextButton onClick={onClickRequestButton}>
                  {intl.formatMessage(messages.requestButton)}
                </TextButton>
                <PrimaryButton onClick={onClickSetupButton}>
                  {intl.formatMessage(messages.setupButton)}
                </PrimaryButton>
              </Space>
            </Space>
          </Space>
        </Modal.Content>
      </Modal.Card>
    </Modal>
  )
}
